module.exports = __webpack_public_path__ + "img/volume_off.c8074194.svg";